import { getModule } from "@companion-core/shared/app/Utils/config";
import { NavigateFunction } from "react-router";

export const isSSORoutePath = (pathname: string): boolean => pathname.startsWith("/sso");

export const hasCodeQueryParam = (searchParams: URLSearchParams): boolean =>
  getModule("sso")?.enabled && searchParams.get("code") !== null;

export const hasLinkCodeQueryParam = (searchParams: URLSearchParams): boolean =>
  getModule("restrictedSession")?.enabled && searchParams.get("link_code");

export const stringSearchToURLSearchParams = (searchString: string): URLSearchParams => {
  const urlSearchParams: URLSearchParams = new URLSearchParams();
  const searchStringItems: string[] = searchString.slice(1).split("&");
  searchStringItems.forEach((searchStringItem) => {
    const keyValueSearchParam: string[] = searchStringItem.split("=");
    urlSearchParams.append(keyValueSearchParam[0], keyValueSearchParam[1]);
  });
  return urlSearchParams;
};

/**
 * Navigate properly to an internal link (ex:"/home") or an external link (ex: "www.macartekdo.com").
 *
 * @param {string} link
 * @param {string} type - The type of navigation, must be "internal" or "external".
 * @param {string} navigate - The navigation function used to navigate in your app. This param is mandatory for internal navigation.
 * @param {string} target - The target param of the window.open function.
 */
export const redirectTo = (
  link: string,
  type: string,
  navigate?: NavigateFunction,
  target?: string
) => {
  if (type === "internal") {
    navigate && navigate(link);
  } else {
    window.open(link, target ?? "_blank", "noopener,noreferrer");
  }
};
